import { render, staticRenderFns } from "./BaseCsvFileIcon.vue?vue&type=template&id=4072e556&scoped=true"
import script from "./BaseCsvFileIcon.vue?vue&type=script&lang=js"
export * from "./BaseCsvFileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072e556",
  null
  
)

export default component.exports